// validators for app

import moment from "moment";

export const isValidString = (value: any) => {
  return value !== "" && value !== undefined && value !== null;
};

export const isValidNumber = (value: number | null | undefined): boolean => {
  return !Number.isNaN(value) && value !== undefined && value !== null;
};

export const todaySameAsGivenDate = (dateString: string) => {
  const givenDate = moment.utc(dateString);
  const currentDate = moment().utc();
  return givenDate.isSame(currentDate, 'day');
}